var _defs, _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArcherx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff9640;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#111;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1.44,
    y: -1.44,
    width: 66.87,
    height: 66.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.49,38.1v6.48c0,.48-.39.87-.87.87h-22.28c-.32,0-.61-.17-.76-.46l-1.92-3.56c-.39-.72-1.13-1.16-1.95-1.16h-12.34c-.48,0-.87-.39-.87-.87v-6.48c0-.48.39-.87.87-.87h10.68c.32,0,.61.17.76.46l1.92,3.56c.39.72,1.13,1.16,1.95,1.16h23.93c.48,0,.87.39.87.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.49,24.59v6.48c0,.48-.39.87-.87.87h-10.68c-.32,0-.61-.17-.76-.46l-1.92-3.56c-.39-.72-1.13-1.16-1.95-1.16H12.38c-.48,0-.87-.39-.87-.87v-6.48c0-.48.39-.87.87-.87h22.28c.32,0,.61.17.76.46l1.92,3.56c.39.72,1.13,1.16,1.95,1.16h12.34c.48,0,.87.39.87.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcherx);
export default __webpack_public_path__ + "static/media/archerx.c5d72a11d3acd1a22f5b33800d42b651.svg";
export { ForwardRef as ReactComponent };